import { render } from "./FormUsuariosAdmin.vue?vue&type=template&id=0662b7a6"
import script from "./FormUsuariosAdmin.vue?vue&type=script&lang=js"
export * from "./FormUsuariosAdmin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__